export default {
  subtitle: "Requesting Bank Accounts ",
  path: "requesting_bank_accounts",
  paragraphs: [
   "Following the previous authorization, this last step is to request the opening of a bank account for the subject_id provided. Notice you should use the same id as in the previous endpoint.",
   "The creation normally occurs in a matter of seconds and, once complete, you will receive a webhook with the updated information. "
  ],
  request:  {
    method: "POST",
    endpoint: "/bank/accounts/request",
    payloads: [
        {
        title: "Request payload sample",
        content: { 
            "subject_id": "93de033d-78db-42f3-9fb6-d2b0abb9a95e", 
            "is_subject_account_owner": false 
        } 
     },
     {
        title: "Just as in the previous endpoint, a webhook is sent to you once the account is created",
        content: {
        "notification": { 
            "reason": null, 
            "subject_id": "93de033d-78db-42f3-9fb6-d2b0abb9a95e", 
            "status": "approved", 
            "type": "subject_account_authorization" 
            } 
        }
     }
    ],
    responses: { 
        "data": { 
            "user_id": "5e018c08-8a3f-43fd-93cf-11f27ba419e2", 
            "subject_id": "93de033d-78db-42f3-9fb6-d2b0abb9a95e", 
            "is_subject_account_owner": false, 
            "status": "processing", 
            "id": "a6a7a710-2bb6-4261-8d56-e7d1a95e6f2b", 
            "errors": null 
        } 
      }
    },
  parameterPayload: [
    {
      name: "subject_id",
      type: "string",
      required: true,
      description: "Where subject_id is your customer’s UUID within the FacilitaPay, the same used on the previous endpoint."
    },
    {
      name: "is_subject_account_owner",
      type: "string",
      required: false,
      description: "This determines whether the subject is going to be the owner of the bank account. If true, payments to this bank account will be handled by this subject's document number. If false (default), the account will be registered under FacilitaPay's name."
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/MarketplaceCollection/RequestingBankAccounts.js